/*
 * DATA_RIGHTS: HONEYWELL CONFIDENTIAL AND PROPRIETARY
 * THIS WORK CONTAINS VALUABLE CONFIDENTIAL AND PROPRIETARY
 * INFORMATION. DISCLOSURE, USE OR REPRODUCTION OUTSIDE OF
 * HONEYWELL INTERNATIONAL, INC. IS PROHIBITED EXCEPT AS
 * AUTHORIZED IN WRITING. THIS UNPUBLISHED WORK IS PROTECTED BY
 * THE LAWS OF THE UNITED STATES AND OTHER COUNTRIES. IN THE
 * EVENT OF PUBLICATION, THE FOLLOWING NOTICE SHALL APPLY:
 * Copyright (C) 2018 HONEYWELL INTERNATIONAL, INC., ALL RIGHTS RESERVED.
 */

import React from 'react'
import {FormattedHTMLMessage, FormattedMessage, injectIntl} from 'react-intl'
import connect from "react-redux/es/connect/connect"
import {withRouter} from "react-router"
import {bindActionCreators} from "redux"
import {
    Button,
    Card,
    DatePicker,
    Grid,
    Input,
    InputLabel,
    List,
    Loader,
    Modal,
    Notification,
    Radio,
    Table
} from "@scuf/common";
import {Routes} from "../../utils/Routes";
import FleetsHierarchy from "../common/FleetsHierarchy";
import {showNotification} from "../../common/ToastNotification";
import {getBreadcrumbItemsAdminAsset} from "../../utils/Helpers";
import BreadCrumb from "../../common/Bradcrumb";
import * as AssetActions from './AssetActions'
import {assetModel, assetModelHda} from "../../model/Asset";
import {getAssetAttributeField, getAssetAttributeValue} from "../common/AssetUtils";
import {userHasActivity} from "../../security/SecurityUtils";
import {ACTIVITY_TYPES} from "../../security/SecurityConst";
import AssetExistNotification from "../common/AssetExistNotification";
import {SYMPTOM_STATES} from "../../faults/common/FaultsConst";
import ExpandablePanel from "../../common/ExpandablePanel";
import * as Fleets from "../../api/Fleets";
import EventLogTable from "./EventLogTable";
import {Link} from "react-router-dom";
import LoosingDataModal from "../../common/LoosingDataModal";
import {fetchLdiNamesAndIds} from "../../api/AppConfigs";
import VariantSelectors from "./VariantSelectors";
import LdiSelector from "../../common/LdiSelector"
import engineHTF7K from '../../styling/images/AS907.png'
import engineTFE731 from '../../styling/images/TFE731.png'

class AssetDetail extends React.Component {

    constructor(props) {
        super(props)

        const {profile, match: { params }} = this.props

        const selectedAssetId = isNaN(params.assetId) ? null : params.assetId;
        this.state = {
            readAccess: !userHasActivity(profile, [ACTIVITY_TYPES.ASSETS_WRITE]),
            paramAssetId: selectedAssetId,
            assetModel: null, //assetModel(intl),
            errors: [],
            errorPaths: [],
            confirmModalOpen: false,
            existingAsset: {
                readAccess: false,
                asset: {},
            },
            selectedVariants: new Map(),
            eventLogs: [],
            formIsDirty: false,
            closeLoosingDataModal: false,
            pathName: '',
            engineType: null,
            engineModel: null,
            configuration: null,
            platform: null,
            ldiNamesAndIds: null,
            selectedLdiForHDR: -1,
        }

        this.fetchFleets = this.fetchFleets.bind(this)
        this.getErrorMessage = this.getErrorMessage.bind(this)
        this.renderDeleteButton = this.renderDeleteButton.bind(this)
        this.submitForm = this.submitForm.bind(this)
        this.fetchAttributes = this.fetchAttributes.bind(this)
        this.fetchVariants = this.fetchVariants.bind(this)
        this.deleteAssetConfirm =  this.deleteAssetConfirm.bind(this)
        this.deleteAsset = this.deleteAsset.bind(this)
        this.enableAsset = this.enableAsset.bind(this)
        this.setConfigurationSymptomValue = this.setConfigurationSymptomValue.bind(this)
        this.fetchEventLogs = this.fetchEventLogs.bind(this)
        this.fetchLdiNamesAndIds = this.fetchLdiNamesAndIds.bind(this)
    }

    fetchLdiNamesAndIds() {
        const me = this
        fetchLdiNamesAndIds().then(function (response) {
            if (response.length === 1) {
                me.setState({ldiNamesAndIds: response, selectedLdiForHDR: response[0].value}, me.fetchVariants)
            }
            else {
                me.setState({ldiNamesAndIds: response})
            }
        });
    }

    fulfillSelectedVariants(variants) {
        const selectedVariants = new Map();
        variants.forEach(v => {
            selectedVariants.set(v.variantType, v)
        })
        return selectedVariants;
    }

    componentDidMount() {
        const {userProfile} = this.props
        this.fetchAsset();
        if (!userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES)) {
            this.fetchFleets()
        }
        if (userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES)) {
            this.fetchVariants();
            this.setState({assetModel: assetModelHda(this.props.intl)})
        }
        else {
            this.setState({assetModel: assetModel(this.props.intl)});
        }
        this.fetchEventLogs();
        this.fetchLdiNamesAndIds()

        this.unblock = this.props.history.block( (a) => {
            if (this.state.formIsDirty) {
                this.setState({closeLoosingDataModal: true, pathName: a})
            }
            return !this.state.formIsDirty;
        })
    }

    componentWillUnmount() {
        this.unblock()
    }

    fetchEventLogs() {
        const me = this
        const idOfAsset = this.state.paramAssetId
        if (idOfAsset != null) {
            Fleets.fetchEventLogs(idOfAsset, undefined, undefined).then(
                function (response) {
                    me.setState({eventLogs: response})
                }
            )
        }
    }

    fetchFleets() {
        this.props.AssetActions.fetchFleetsHierarchy()
    }

    fetchAsset() {
        const me = this
        if(!this.state.paramAssetId) {
            this.props.AssetActions.clearState();
        } else {
            this.props.AssetActions.fetchAsset(this.state.paramAssetId).then(() => {
               if (me.props.asset.variants.length > 0) {
                   me.getAvailableConfigurationSymptoms(me.props.asset.variants.map(v => {
                       return v.id
                   }), me.props.asset.id, me.props.asset.ldiId)
                   me.setState({
                       selectedVariants: me.fulfillSelectedVariants(me.props.asset.variants),
                       engineType: me.props.asset.variants.length > 0 ? me.props.asset.variants[0].engineType : null,
                       engineModel: me.props.asset.variants.length > 0 ? me.props.asset.variants[0].engineModel : null,
                       configuration: me.props.asset.variants.length > 0 ? me.props.asset.variants[0].configuration : null,
                       platform: me.props.asset.variants.length > 0 ? me.props.asset.variants[0].platform : null,
                   })
               }
               this.setState({selectedLdiForHDR: me.props.asset.ldiId}, () => {
                   this.fetchAttributes();
                   this.fetchVariants();
               })
            });
        }
    }

    fetchAttributes() {
        this.props.AssetActions.fetchAttributes(this.state.selectedLdiForHDR);
    }

    fetchVariants() {
        this.props.AssetActions.fetchVariants(this.state.selectedLdiForHDR);
    }

    getAvailableConfigurationSymptoms(variants, assetId, ldiId) {
        const asset = assetId == null ? this.state.paramAssetId : assetId
        this.props.AssetActions.fetchAvailableConfigurationSymptoms(variants, asset, ldiId);
    }

    setAssetAttribute(key, value) {
        this.setState({formIsDirty: true})
        if (key === 'fleetId') {
            value = (value != null && value.length > 0) ? value[0].substr('fleet_'.length) : null;
        }
        this.props.AssetActions.setAssetAttribute(key, value);
    }

    setAssetConfigurableAttribute(code, property, value) {
        this.props.AssetActions.setAssetConfigurableAttribute(code, property, value);
    }

    getErrorMessage(fields) {
        const errs = []
        fields.forEach(field => errs.push(this.state.errorPaths.find(err => err.path === field)))

        return errs.filter(err => err != null).reduce(
            (composeMsg, err) => composeMsg ? composeMsg + "<br/>" + err.message : err.message, null)
    }

    submitForm() {
        const {intl, history, asset, availableConfigurationSymptoms, userProfile} = this.props;

        const attributes = [];
        for (const i in asset.attributes) {
            if (asset.attributes.hasOwnProperty(i)) {
                const attr = asset.attributes[i];
                if (attr.dataType === 'string' && (attr.valueString != null)) {
                    attributes.push({code: attr.code, value: attr.valueString, type: attr.dataType})
                } else if (attr.dataType === 'date' && (attr.valueDate != null)) {
                    if (attr.valueDate instanceof Date) {
                        attr.valueDate.setTime(attr.valueDate.getTime() - attr.valueDate.getTimezoneOffset() * 60 * 1000)
                        attributes.push({code: attr.code, value: attr.valueDate.toISOString(), type: attr.dataType})
                    } else {
                        attributes.push({code: attr.code, value: attr.valueDate, type: attr.dataType})
                    }
                } else if (attr.dataType === 'integer' && (attr.valueInteger != null)) {
                    attributes.push({code: attr.code, value: attr.valueInteger, type: attr.dataType})
                } else if (attr.dataType === 'float' && (attr.valueFloat != null)) {
                    attributes.push({code: attr.code, value: attr.valueFloat, type: attr.dataType})
                } else {
                    // Do not push any data
                }
            }
        }

        const variantArray = [...this.state.selectedVariants.values()];
        const variantIds = [];
        const ldiId = this.state.selectedLdiForHDR
        for (const i in variantArray) {
            if (variantArray.hasOwnProperty(i)) {
                variantIds.push(variantArray[i].id);
            }
        }

        const newConfigurationSymptoms = availableConfigurationSymptoms.filter(s => s.newState != null).map(s => {
            return {id: s.id, name: s.name, state: s.newState}
        })

        const myAsset = {
            id: asset.id,
            name: asset.name,
            fleetId: userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES) ? 1 : asset.fleetId,
            attributes: attributes,
            variants: variantIds,
            ldiId: ldiId,
            configurationSymptoms: newConfigurationSymptoms,
            engineType: this.state.engineType,
            engineModel: this.state.engineModel,
            configuration: this.state.configuration,
            platform: this.state.platform,
        }

        this.state.assetModel.validate(myAsset, {abortEarly: false}).then(() => {
            this.setState({errorPaths: [], errors: []})
            if (myAsset.id == null) {
                this.setState({errors: []})
                this.props.AssetActions.createAsset(myAsset, userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES)).then((newAsset) => {
                    this.setState({formIsDirty: false})
                    userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES) ?
                        history.push(Routes.ASSETS_ADMIN)
                        :
                        history.push(Routes.FLEETS_ADMIN)
                    showNotification({title: intl.formatMessage({id: 'admin.asset.created'}, {name: newAsset.name})})
                }).catch(err => {
                    if (err.errorKey === 'business.exception.ASSET_NAME_ALREADY_EXISTS') {
                        this.setState({errorPaths: [{path: 'name', message: intl.formatMessage({id: 'admin.asset.ASSET_NAME_ALREADY_EXISTS'}, {name: asset.name})}]})
                        if(err.params && err.params.length === 2 ) {
                            this.setState({existingAsset: {readAccess: err.params[0], asset: err.params[1]}});
                        }
                    }
                });
            } else {
                this.setState({errors: []})
                this.props.AssetActions.updateAsset(myAsset).then((updatedAsset) => {
                    this.setState({formIsDirty: false})
                    userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES) ?
                        history.push(Routes.ASSETS_ADMIN)
                        :
                        history.push(Routes.FLEETS_ADMIN)
                    const body =
                        <ul className="asset-notification">
                            <FormattedMessage id="admin.asset.notification.updatedAsset"/>
                            <Link to={`/administration/assets/${updatedAsset.id}`}><Button
                                type="link">{updatedAsset.name}</Button></Link>
                        </ul>
                    showNotification({
                        title: intl.formatMessage({id: 'admin.asset.updated'}, {name: updatedAsset.name}),
                        body: body,
                    })
                }).catch(err => {
                    if (err.errorKey === 'business.exception.ASSET_NAME_ALREADY_EXISTS') {
                        this.setState({errorPaths: [{path: 'name', message: intl.formatMessage({id: 'admin.asset.ASSET_NAME_ALREADY_EXISTS'}, {name: asset.name})}]})
                    }
                    else if (err.errorKey === 'business.exception.VARIANT_EXCEPTION') {
                        this.setState({errorPaths: [{path: 'variants', message: intl.formatMessage({id: 'admin.asset.VARIANT_EXCEPTION_OPEN_FAULTS'})}]})
                    }
                });
            }
        }).catch(err => {
            if(err.inner && err.inner.map) {
                this.setState({
                    errors: err.errors, errorPaths: err.inner.map(i => {
                        return {path: i.path, message: i.errors}
                    }),
                })
            }
        })
    }

    deleteAssetConfirm() {
        this.setState({confirmModalOpen: true})
    }

    deleteAsset() {
        const {asset, intl, history, userProfile} = this.props
        const successMessageId = asset.faultsCountIncludingClosed === 0 ? 'admin.asset.detail.delete.successful'
            : 'admin.asset.detail.disable.successful'

        this.props.AssetActions.deleteAsset(asset.id).then(() => {
            showNotification({
                translationPropertyKey: successMessageId,
                severity: "success",
            })
            this.setState({confirmModalOpen: false, formIsDirty: false})
            userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES) ?
                history.push(Routes.ASSETS_ADMIN)
                :
                history.push(Routes.FLEETS_ADMIN)
        }).catch(() => {     // we need this otherwise error message is not displayed
            this.setState({confirmModalOpen: false, formIsDirty: false})
        })
    }

    enableAsset() {
        const {asset} = this.props
        this.props.AssetActions.enableAsset(asset.id);
    }

    getConfigurationSymptomRows(configurationSymptoms, disabled) {
        return configurationSymptoms.map((o, i) => {
            const realState = o.newState || o.state
            return (
                <React.Fragment key={o.id}>
                    <Table.Row className={this.getRowClass("extra-row mobile only", i)}>
                        <Table.Cell colSpan="5">
                            {o.description}
                        </Table.Cell>
                    </Table.Row>
                    <Table.Row className={this.getRowClass("", i)}>
                        <Table.Cell className="computer only">
                            {o.description}
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                            {this.getConfigurationSymptomRadioButton(o.id, SYMPTOM_STATES.PRESENT, realState, disabled)}
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                            {this.getConfigurationSymptomRadioButton(o.id, SYMPTOM_STATES.ABSENT, realState, disabled)}
                        </Table.Cell>
                        <Table.Cell textAlign="center">
                            {this.getConfigurationSymptomRadioButton(o.id, SYMPTOM_STATES.UNKNOWN, realState, disabled)}
                        </Table.Cell>
                    </Table.Row>
                </React.Fragment>
            )
        })
    }

    getRowClass(className, index) {
        return className + ' ' + (index % 2 === 0 ? 'even' : 'odd')
    }

    getConfigurationSymptomRadioButton(id, value, currentValue, disabled) {
        return (
            <Radio
                name={'configurationSymptom-'+id}
                checked={currentValue === value}
                onChange={() => this.setConfigurationSymptomValue(id, value)}
                disabled={this.state.readAccess || disabled === 'DISABLED'}
            />
        )
    }

    setConfigurationSymptomValue(id, value) {
        this.props.AssetActions.setConfigurationSymptom(id, value);
    }

    renderAvailableConfigurationSymptoms(availableConfigurationSymptoms, disabled) {
        const {intl} = this.props
        const availableRows = this.getConfigurationSymptomRows(availableConfigurationSymptoms, disabled)
        return (
            <Grid.Row>
                <Grid.Column>
                    <ExpandablePanel className="expandable-panel-config-symptoms" title={intl.formatMessage({id: "admin.asset.detail.configurationSymptoms"})} count={1} expanded={true}>
                        {
                            availableConfigurationSymptoms.length === 0 ?
                                <div className="no-availabe-config-sym"><FormattedMessage id="admin.asset.configurationSymptom.empty"/></div>
                            :
                                <Table className="configurationSymptomsTable unstackable">
                                    <Table.Header>
                                        <Table.HeaderCell content={intl.formatMessage({id: "admin.asset.configurationSymptom"})}
                                                          className="computer only"/>
                                        <Table.HeaderCell content={intl.formatMessage({id: "fault.troubleshoot.table.header.present"})}
                                                          textAlign="center" className="radio-cell"/>
                                        <Table.HeaderCell content={intl.formatMessage({id: "fault.troubleshoot.table.header.absent"})}
                                                          textAlign="center" className="radio-cell"/>
                                        <Table.HeaderCell content={intl.formatMessage({id: "fault.troubleshoot.table.header.unknown"})}
                                                          textAlign="center" className="radio-cell"/>
                                    </Table.Header>
                                    <Table.Body>
                                        {availableRows}
                                    </Table.Body>
                                </Table>
                        }
                    </ExpandablePanel>
                </Grid.Column>
            </Grid.Row>
        )
    }

    render() {
        const {intl, history, asset, fleetsHierarchy, loading, attributes, variants, availableConfigurationSymptoms, userProfile} = this.props

        const breadCrumbs = getBreadcrumbItemsAdminAsset(intl, asset, userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES))
        const selectedParentFleetId = (asset.fleetId != null) ? ['fleet_' + asset.fleetId] : [];

        const configurationSymptoms = this.renderAvailableConfigurationSymptoms(availableConfigurationSymptoms.map(v => {
            return {id: v.id, description: v.name, state: v.state, newState: v.newState}
        }), asset.status)

        // If is normal HDR environment (not HDA) is needed to pick the LDI if multiple available, before create the asset
        let ldiSelector = null
        if (this.state.ldiNamesAndIds != null && this.state.ldiNamesAndIds.length > 1) {
            ldiSelector =
                <LdiSelector
                    ldiNamesAndIds={this.state.ldiNamesAndIds}
                    selectedLdiForHDR={this.state.selectedLdiForHDR}
                    onLdiChange={(data) => {
                        this.setState({
                            selectedLdiForHDR: data,
                            selectedVariants: new Map(),
                        }, () => {
                            this.fetchAttributes()
                            this.fetchVariants()
                        });
                    }}
                    getErrorMessage={(data) => this.getErrorMessage(data)}
                />
        }

        const me = this

        return (
            <React.Fragment>
                <LoosingDataModal
                    open={this.state.closeLoosingDataModal}
                    onClose={() => {
                        this.setState({closeLoosingDataModal: false})
                    }}
                    onContinue={() => {
                        this.setState({formIsDirty: false, closeLoosingDataModal: false},
                            () => {
                                userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES) ?
                                    this.props.history.push(Routes.ASSETS_ADMIN)
                                    :
                                    this.props.history.push(Routes.FLEETS_ADMIN)
                            })
                    }
                    }
                />
                <Modal size="small" closeIcon={true} open={this.state.confirmModalOpen}
                       onClose={() => this.setState({confirmModalOpen: false})} closeOnDimmerClick={false}>
                    {this.renderModalHeader()}
                    {this.renderModalContent()}
                    {this.renderModalFooter()}
                </Modal>
                <BreadCrumb items={breadCrumbs} />
                {!userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES) && this.state.ldiNamesAndIds != null && this.state.ldiNamesAndIds.length > 1 ?
                    <Card>
                        <Card.Header title={intl.formatMessage({id: "multipleLdis.selection.header"})}/>
                        <Card.Content>
                            <Grid>
                                <Grid.Row>
                                    <Grid.Column width={4} sWidth={12}>
                                        <div className="ldiSelector">
                                            {ldiSelector}
                                        </div>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </Card.Content>
                    </Card>
                    :
                    null
                }
                <Card>
                    <Loader loading={loading} />
                    <Card.Header title={intl.formatMessage({id: 'admin.asset.detail.title'})}>
                        <div className="right">
                            {this.renderEnableButton()}
                        </div>
                    </Card.Header>
                    <Card.Content>
                        <Grid>
                            <Grid.Row>
                                {
                                    userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES) && asset.variants.length > 0 ?
                                        <div className="engine-picture-div">
                                            <Grid.Column width={2} sWidth={12}>
                                                <div>
                                                    <img alt="engine" className="engine-picture" src={asset.variants[0].ldiName.includes('HTF7K') ? engineHTF7K : engineTFE731}/>
                                                    <FormattedHTMLMessage id={asset.variants[0].ldiName.includes("HTF7K") ? "HTF7K" : "TFE731"}/>
                                                </div>
                                            </Grid.Column>
                                        </div>
                                        :
                                        null
                                }
                                <Grid.Column width={4} sWidth={12}>
                                    <div>
                                        <InputLabel label={intl.formatMessage({id: 'admin.asset.detail.name'})} />
                                        <Input fluid
                                               onChange={value => {this.setAssetAttribute('name', value);}}
                                               value={asset.name}
                                               placeholder={intl.formatMessage({id: "admin.asset.detail.name"})}
                                               error={this.getErrorMessage(['name'])}
                                               disabled={(asset.id == null || isNaN(asset.id) ? false : true )}

                                        />
                                    </div>
                                </Grid.Column>
                                {userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES) ?
                                    null
                                    :
                                    <Grid.Column width={8} sWidth={12}>
                                        <div>
                                            <InputLabel label={intl.formatMessage({id: 'admin.asset.detail.fleet'})}/>
                                            <FleetsHierarchy fleetsHierarchy={fleetsHierarchy}
                                                             asDropdown={true}
                                                             selectionChanged={value => {
                                                                 this.setAssetAttribute('fleetId', value);
                                                             }}
                                                             selectedItems={selectedParentFleetId}
                                                             error={this.getErrorMessage(['fleetId'])}
                                                             rootSelectable={true}
                                                             disabled={this.state.readAccess || asset.status === 'DISABLED'}
                                                             selectableFleetParentsOnly={false}
                                                             selectableAssetParentsOnly={true}
                                                             showAssets={false}
                                                             placeholder={intl.formatMessage({id: "admin.asset.detail.select.fleet"})}
                                            />
                                        </div>
                                    </Grid.Column>
                                }
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={12}>
                                    <AssetExistNotification existingAsset={this.state.existingAsset} />
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </Card.Content>
                </Card>
                <Card className={"variantCard"}>
                    <Loader loading={loading} />
                    <Card.Header title={intl.formatMessage({id: 'admin.asset.detail.variants'})}>
                    </Card.Header>
                    <Card.Content>
                        <Grid>
                            <VariantSelectors
                                assetStatus={asset.status}
                                readAccess={this.state.readAccess}
                                variants={variants}
                                selectedVariants={this.state.selectedVariants}
                                onVariantChange={(data, variantType) => {
                                    const newSelectedVariants = new Map(this.state.selectedVariants)
                                    newSelectedVariants.set(variantType, variants.get(variantType).find(function (element) {
                                        return element.id === data;
                                    }));
                                    this.setState({selectedVariants: newSelectedVariants})
                                    const selectedVariantIds = [...newSelectedVariants.values()]
                                    this.getAvailableConfigurationSymptoms(selectedVariantIds.map(v => {
                                        return v.id
                                    }), asset.id, me.state.selectedLdiForHDR)
                                }}
                                engineType={me.state.engineType}
                                engineModel={me.state.engineModel}
                                configuration={me.state.configuration}
                                platform={me.state.platform}
                                onEngineTypeChange={(data) => {
                                    this.setState({
                                        engineType: data,
                                        engineModel: null,
                                        configuration: null,
                                        platform: null,
                                    })
                                }}
                                onEngineModelChange={(data) => {
                                    this.setState({
                                        engineModel: data,
                                        configuration: null,
                                        platform: null,
                                    })
                                }}
                                onConfigurationChange={(data) => {
                                    this.setState({
                                        configuration: data,
                                        platform: null,
                                    })
                                }}
                                onPlatformChange={(data, variantType) => {
                                    // HDA can have just 1 variant per Asset (there doesn't matter on Variant types)
                                    const newSelectedVariants = new Map()
                                    newSelectedVariants.set(variantType, variants.get(variantType).find(v =>
                                        v.engineType === me.state.engineType &&
                                        v.engineModel === me.state.engineModel &&
                                        (v.configuration == null || v.configuration === me.state.configuration) &&
                                        v.platform === data
                                    ));
                                    this.setState({
                                        selectedVariants: newSelectedVariants,
                                        platform: data,
                                        selectedLdiForHDR: newSelectedVariants.get(variantType).ldiId,
                                    }, () => this.fetchAttributes());
                                }}
                                getErrorMessage={(data) => this.getErrorMessage(data)}
                            />
                        </Grid>
                    </Card.Content>
                </Card>
                <Card className={"configurationSymptomsPanel"}>
                    <Loader loading={loading}/>
                    <Card.Content>
                        <Grid>
                            {configurationSymptoms}
                        </Grid>
                    </Card.Content>
                </Card>
                <Card>
                    <Loader loading={loading} />
                    <Card.Header title={intl.formatMessage({id: 'admin.asset.detail.attributes'})}/>
                    <Card.Content>
                        <Grid>
                            <Grid.Row>
                                {this.renderAttributes(attributes, asset, this.state.readAccess)}
                            </Grid.Row>
                        </Grid>
                    </Card.Content>
                </Card>
                <Card>
                    <Loader loading={loading}/>
                    <Card.Header title={intl.formatMessage({id: 'admin.asset.detail.log'})}/>
                    <Card.Content>
                        <EventLogTable eventLog={this.state.eventLogs}/>
                    </Card.Content>
                </Card>
                <div>
                    <div className="delete-button-div">
                        {this.renderDeleteButton()}
                    </div>
                    <div className="cancel-save-button-div">
                        <Button
                            type="secondary"
                            content={intl.formatMessage({id: "admin.asset.detail.cancel"})}
                            onClick={() => {
                                if (history.length > 2) {
                                    history.goBack()
                                } else {
                                    userHasActivity(userProfile, ACTIVITY_TYPES.HDA_FUNCTIONALITIES) ?
                                        history.push(Routes.ASSETS_ADMIN)
                                        :
                                        history.push(Routes.FLEETS_ADMIN)
                                }
                            }}
                            className="cancel-save-delete-button mobile-max-width-button"
                        />
                        <Button
                            type="primary"
                            content={intl.formatMessage({id: "admin.asset.detail.save"})}
                            onClick={this.submitForm}
                            disabled={this.state.readAccess  || asset.status === 'DISABLED'}
                            className="cancel-save-delete-button mobile-max-width-button"
                        />
                    </div>

                </div>
            </React.Fragment>
        )
    }


    renderDeleteButton() {
        const {intl, asset} = this.props
        const deleteButtonLabel = asset.faultsCountIncludingClosed > 0 ? intl.formatMessage({id: "admin.asset.detail.disable"})
            : intl.formatMessage({id: "admin.asset.detail.delete"})

        if (asset.id != null && asset.status !== 'DISABLED') {
            return (
                <Button
                    type="secondary"
                    content={deleteButtonLabel}
                    onClick={this.deleteAssetConfirm}
                    disabled={this.state.readAccess}
                    className="cancel-save-delete-button mobile-max-width-button"
                />
            )
        }
        return null
    }

    renderModalHeader() {
        const {asset} = this.props

        if (asset.faultsCount > 0 || asset.faultsCountIncludingClosed > 0) {
            return (
                <Modal.Header>
                    <FormattedMessage id="admin.asset.detail.disable.modal.header"/>
                </Modal.Header>
            )
        } else {
            return (
                <Modal.Header>
                    <FormattedMessage id="admin.asset.detail.delete.modal.header"/>
                </Modal.Header>
            )
        }
    }

    renderModalContent() {
        const {asset} = this.props

        if(asset.faultsCount > 0) {
            return (
                <Modal.Content>
                    <div>
                        <Notification hasIcon={true} severity="important">
                            <FormattedHTMLMessage id="admin.asset.detail.delete.modal.can.not.disable.asset" values={{assetName: asset.name}} />
                            <List divided>
                                <List.Content>
                                    <FormattedHTMLMessage id="admin.asset.detail.delete.modal.can.not.disable.faults.count" values={{faultCount: asset.faultsCount}} />
                                </List.Content>
                                <List.Content>
                                </List.Content>
                            </List>
                        </Notification>
                    </div>
                </Modal.Content>
            )
        } else if (asset.faultsCountIncludingClosed > 0) {
            return (
                <Modal.Content>
                    <div>
                        <FormattedMessage id="admin.asset.detail.disable.modal.description" values={{'assetName': asset.name}}  />
                    </div>
                </Modal.Content>
            )
        } else {
            return (
                <Modal.Content>
                    <div>
                        <FormattedMessage id="admin.asset.detail.delete.modal.description" values={{'assetName': asset.name}}  />
                    </div>
                </Modal.Content>
            )
        }
    }

    renderModalFooter() {
        const {intl, asset} = this.props

        if(asset.faultsCount > 0) {
            return (
                <Modal.Footer>
                    <Button type="primary" size="medium" content={intl.formatMessage({id: 'admin.fleets.detail.delete.modal.cancel'})} onClick={() => this.setState({confirmModalOpen: false})}/>
                </Modal.Footer>
            )
        } else if (asset.faultsCountIncludingClosed > 0) {
            return (
                <Modal.Footer>
                    <Button type="secondary" size="medium" content={intl.formatMessage({id: 'admin.asset.detail.delete.modal.cancel'})} onClick={() => this.setState({confirmModalOpen: false})}/>
                    <Button type="primary" size="medium" content={intl.formatMessage({id: 'admin.asset.detail.delete.modal.disable'})} onClick={this.deleteAsset}/>
                </Modal.Footer>
            )
        } else {
            return (
                <Modal.Footer>
                    <Button type="secondary" size="medium" content={intl.formatMessage({id: 'admin.asset.detail.delete.modal.cancel'})} onClick={() => this.setState({confirmModalOpen: false})}/>
                    <Button type="primary" size="medium" content={intl.formatMessage({id: 'admin.asset.detail.delete.modal.delete'})} onClick={this.deleteAsset}/>
                </Modal.Footer>
            )
        }
    }

    renderAttributes(attributes, asset, readAccess) {
        if(typeof attributes === 'undefined') {
            return <div className="no-attributes-available"><FormattedMessage id="admin.asset.detail.attributes.noAvailable"/></div>;
        }

        const elements = [];

        attributes.forEach((attributeDefinition, index) => {  // elements ordered by attributeDefinition
            if(attributeDefinition.type === 'string') {
                elements.push(this.renderInput(asset, attributeDefinition, index, readAccess))
            } else if (attributeDefinition.type === 'date') {
                elements.push(this.renderDate(asset, attributeDefinition, index, readAccess))
            } else if (attributeDefinition.type === 'integer') {
                elements.push(this.renderInput(asset, attributeDefinition, index, readAccess))
            } else if (attributeDefinition.type === 'float') {
                elements.push(this.renderInput(asset, attributeDefinition, index, readAccess))
            } else {
                // Do not push any element
            }
        })

        if (elements.length === 0) {
            return <div className="no-attributes-available"><FormattedMessage id="admin.asset.detail.attributes.noAvailable"/></div>;
        }

        return(elements);
    }

    renderInput(asset, attributeDefinition, index, readAccess) {
        const assetId = (asset.id) ? asset.id : 'new'

        return (
            <Grid.Row key={'asset_'+assetId+'_attribute_'+attributeDefinition.code}>
                <Grid.Column width={4} sWidth={12}>
                    <Input fluid
                           onChange={value => {this.setAssetConfigurableAttribute(attributeDefinition.code, getAssetAttributeField(attributeDefinition.type), value);}}
                           value={ getAssetAttributeValue(attributeDefinition, asset.attributes)}
                           placeholder={attributeDefinition.name}
                           error={this.getErrorMessage(['attributes['+index+'].value'])}
                           label={attributeDefinition.name}
                           disabled={readAccess || asset.status === 'DISABLED'}
                    />
                </Grid.Column>
            </Grid.Row>)
    }

    renderDate(asset, attributeDefinition, index, readAccess) {
        const assetId = (asset.id) ? asset.id : 'new'
        return (
            <Grid.Row key={'asset_'+assetId+'_attribute_'+attributeDefinition.code}>
                <Grid.Column  width={4} sWidth={12}>
                    <DatePicker fluid
                        label={attributeDefinition.name}
                        placeholder={attributeDefinition.name}
                        firstDayOfWeek="mon"
                        disablePast={false}
                        disableWeekends={false}
                        highlightWeekends={false}
                        showYearSelector={true}
                        timezone=""
                        error={this.getErrorMessage(['attributes['+index+'].value'])}
                        value={ getAssetAttributeValue(attributeDefinition, asset.attributes) }
                        onChange={value => {this.setAssetConfigurableAttribute(attributeDefinition.code, getAssetAttributeField(attributeDefinition.type), value);}}
                        disabled={readAccess || asset.status === 'DISABLED'}
                    />
                </Grid.Column>
            </Grid.Row>)
    }



    renderEnableButton() {
        const {asset, intl} = this.props
        const {create} = this.state

        if(create || asset.status !== 'DISABLED') {
            return null;
        }

        return (
            <Button
                type="secondary"
                content={intl.formatMessage({id: "admin.asset.detail.enable"})}
                disabled={this.state.readAccess}
                onClick={this.enableAsset}
                className="top-button-space"
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        asset: state.assetReducer.asset,
        fleetsHierarchy: state.assetReducer.fleetsHierarchy,
        loading: state.assetReducer.loading,
        attributes: state.assetReducer.attributes,
        profile: !state.security ? null : state.security.userProfile,
        variants: state.assetReducer.variants,
        availableConfigurationSymptoms: state.assetReducer.availableConfigurationSymptoms,
        userProfile: state.security.userProfile,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        AssetActions: bindActionCreators(AssetActions, dispatch),
    }
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(AssetDetail)))
